import { useEffect, useState } from 'react'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import RosterComponent from 'src/supportPortal/components/common/roster/RosterComponent'
import { buildNewRosterRequest } from 'src/supportPortal/components/common/roster/utils'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import TherapistRosterForm from 'src/supportPortal/views/roster/component/form/TherapistRosterForm'
import TherapistRosterItemViewer from 'src/supportPortal/views/roster/component/viewers/TherapistRosterItemViewer'
import { buildMentorObjectsWithTheirAssociatedChambers } from 'src/supportPortal/views/therapistRoster/util'

export default function TherapistRosterPage({
  preSelectedMentorSlug,
  hideMentorSelectionDropDown = false,
}) {
  const [allClinicAssociatedMentors, setAllClinicAssociatedMentors] = useState()
  const [selectedMentorWithAssociations, setSelectedMentorWithAssociations] = useState()
  const [loading, setLoading] = useState(false)

  async function getAllClinicAssociatedMentors() {
    const resp = await getSPDataWithParams('/api/secure/cc/support/mentors/list', {
      sendAssociatedChambers: true,
      mentorEventTypes: 'screening,therapy-session',
    })
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const mentorData = getDataMapFromCommonResponse(resp)?.mentor
        const roomsData = getDataMapFromCommonResponse(resp)?.['chamber-room']

        const finalMentorList = buildMentorObjectsWithTheirAssociatedChambers({
          mentorList: mentorData,
          chamberList: roomsData,
        })
        setAllClinicAssociatedMentors(finalMentorList)
        const selectedMentor = preSelectedMentorSlug ? finalMentorList?.find((mentor) => mentor.slug === preSelectedMentorSlug) : finalMentorList?.[0]

        setSelectedMentorWithAssociations(selectedMentor)
      }
    }
  }

  async function setup() {
    setLoading(true)
    await Promise.all([getAllClinicAssociatedMentors()])
    setLoading(false)
  }

  useEffect(() => {
    setup()
  }, [])

  console.log({ selectedMentorClinicAssociations: selectedMentorWithAssociations })

  return (
    <div className="d-flex flex-column h-100">
      <SupportHeader
        heading={
          <span>
            {selectedMentorWithAssociations ? (
              <>
                <span className="fw-light">{selectedMentorWithAssociations.title}</span>
              </>
            ) : (
              'Therapist'
            )}{' '}
            Roster
          </span>
        }
      />
      <RosterComponent
        loadingData={loading}
        itemOptions={allClinicAssociatedMentors}
        hideOptionSelectionDropDown = {hideMentorSelectionDropDown}
        getOptionLabel={(optn) => `${optn?.firstName}`}
        getOptionValue={(optn) => optn?.id}
        getSidebarLegendItems={(room) => room?.associatedChambers}
        getSidebarLegendValue={(leg) => leg?.id}
        getSidebarLegendValueBySecondaryKey={(leg) => leg?.clinicLocationId}
        getSidebarLegendLabel={(leg) =>
          `${leg?.clinicBrandName} | 
            ${leg?.clinicLocationName} | 
            ${leg?.title}`
        }
        bookedSlotsFetchApiSignature={
          '/api/secure/cc/support/events/booked-slots/all-with-patient-info'
        }
        bookedSlotsApiIdParamKey="mentorId"
        legendTitle="Rooms"
        rosterApiIdParamKey="mentorId"
        rosterListFetchApiSignature="/api/secure/cc/support/roster/mentor"
        sidebarLegends={selectedMentorWithAssociations?.associatedChambers}
        getSidebarItemReferenceFromRosterItem={(rosterItem) => rosterItem?.chamberRoomId}
        getSelectedItemSchedules={(selectedRoom) => selectedRoom?.clinicLocationSchedule || []}
        selectedItem={selectedMentorWithAssociations}
        setSelectedItem={setSelectedMentorWithAssociations}
        RosterFormComponent={TherapistRosterForm}
        RosterSlotViewComponent={TherapistRosterItemViewer}
        rosterRequestBuilder={({
          startTimeString,
          endTimeString,
          currentDateString,
          selectedItem,
        }) => {
          return buildNewRosterRequest(
            null,
            null,
            null,
            selectedItem?.id,
            currentDateString,
            startTimeString,
            endTimeString,
          )
        }}
      />
    </div>
  )
}
